import type { FC, ReactElement } from "react"

import eq from "lodash-es/eq"
import includes from "lodash-es/includes"

import { ESessionInvitationStatus } from "@/3514/types"
import { buildCssClassName } from "@/3514/utils"

import { rsvpMarkConfig as config } from "./rsvp-mark.config"

type TProps = { status: ESessionInvitationStatus }

const Component: FC<TProps> = ({ status }: TProps): ReactElement => (
    <i
        className={buildCssClassName(
            "w-[15px] h-[15px] rounded-full flex items-center justify-center not-italic",
            includes<ESessionInvitationStatus>(
                [ESessionInvitationStatus.Present, ESessionInvitationStatus.NotPresent],
                status
            )
                ? [
                      "text-black",
                      eq(status, ESessionInvitationStatus.Present) && "bg-green-200",
                      eq(status, ESessionInvitationStatus.NotPresent) && "bg-red-200"
                  ]
                : "bg-transparent border-[1px] border-dashed text-gray-200 border-gray-200",
            includes<ESessionInvitationStatus>(
                [ESessionInvitationStatus.Tentative, ESessionInvitationStatus.Pending],
                status
            )
                ? "font-[700]"
                : "font-[800]",
            {
                "text-[13px] ml-[1px]": includes<ESessionInvitationStatus>(
                    [ESessionInvitationStatus.NotPresent, ESessionInvitationStatus.Declined],
                    status
                ),
                "text-[10px]": includes<ESessionInvitationStatus>(
                    [ESessionInvitationStatus.Tentative, ESessionInvitationStatus.Pending],
                    status
                ),
                "text-[7px]": includes<ESessionInvitationStatus>(
                    [ESessionInvitationStatus.Accepted, ESessionInvitationStatus.Present],
                    status
                )
            }
        )}
    >
        {status ? config.symbolsMap[status] : null}
    </i>
)

Component.displayName = "RsvpMark"

export { Component as RsvpMark, type TProps as TRsvpMarkProps }
